export class PhoneNumber {
  private constructor(private value: string) {}

  static create(phoneNumber: string) {
    return new PhoneNumber(phoneNumber)
  }

  getValue() {
    return this.value
  }
}
